import React, { useEffect, useState, useRef } from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import {
  Box,
  Divider,
  Typography,
  useMediaQuery,
} from "@mui/material";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { styled } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";
import MenuItem from "@mui/material/MenuItem";
import {
  CitySelect,
  CountrySelect,
  StateSelect,
} from "react-country-state-city";
import "react-country-state-city/dist/react-country-state-city.css";
import { colors, fonts, size } from "../../ColorFont/color";
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { url } from "../../ConstUrl/Url";
import { useTranslation } from "react-i18next";
import { IconArrowLeft, IconUpload, IconX } from "@tabler/icons-react";
import NewHeaderNavWithSidebar from '../../components/HeaderNav/NewHeaderNavWithSidebar';

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const _OldAddPlots = ({
  setShowCard,
  setShowBtn,
  setAddPlots,
  userData,
  onFileCancel,
  setIsRender,

}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useTranslation();
  const [category, setCategory] = useState("");
  const [area, setArea] = useState("");
  const [amount, setAmount] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [countryid, setCountryid] = useState(101);
  const [stateid, setstateid] = useState(0);
  const [country, setCountry] = useState("India");
  const [state, setState] = useState("");
  const [taluka, setTaluka] = useState("");
  const [village, setVillage] = useState("");
  const [categories, setCategories] = useState([]); // To store fetched categories
  const [selectedCategory, setSelectedCategory] = useState(""); // Selected category
  const [selectedAreaUnit, setSelectedAreaUnit] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [subCategories, setSubCategories] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [showCountry, setShowCountry] = useState(false);
  const [showSubCat, setShowSubCat] = useState(false);
  useEffect(() => {
    fetch(`${url}/api/get-categories`)
      .then((response) => response.json())
      .then((data) => {
        setCategories(data);
      })
      .catch((error) => console.error(error));
  }, [showCountry, showSubCat]);

  useEffect(() => {
    if (selectedCategory) {
      const category = categories.find(
        (category) => category.categoryType === selectedCategory
      );
      if (category) {
        setSubCategories(category.subCategories);
      }
    }
  }, [selectedCategory]);

  const handleChange = (event) => {
    const { target } = event;
    const value = target.value;
    const name = target.name;
    switch (name) {
      case "village":
        setVillage(value);
        break;
      case "category":
        setCategory(value);
        const selectedCategory = categories.find(
          (categoryData) => categoryData.categoryType === value
        );
        if (selectedCategory) {
          setSubCategories(selectedCategory.subCategories);
        } else {
          setSubCategories([]);
        }
        break;
      case "subCategory":
        setSubCategory(value);

        break;
      case "area":
        setArea(value);
        break;
      case "areaUnit":
        setSelectedAreaUnit(value);
      case "amount":
        setAmount(value);
        break;
      case "contactNumber":
        setContactNumber(value);
        break;
      default:
        break;
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData();
    formData.append("country", country);
    formData.append("state", state);
    formData.append("taluka", taluka);
    formData.append("village", village);
    formData.append("area", area);
    formData.append("areaUnit", selectedAreaUnit);
    formData.append("amount", amount);
    formData.append("contactNumber", userData.phoneNumber);
    formData.append("user", userData?._id);
    formData.append("category", selectedCategory);
    formData.append("subCategory", selectedSubCategory);
    selectedFiles.forEach((file) => {
      formData.append("photos", file);
    });

    try {
      const response = await fetch(`${url}/api/plots`, {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        alert("Plot details submitted successfully!");
      } else {
        const errorData = await response.json();
        alert(`Failed to submit: ${errorData.error}`);
      }
    } catch (error) {
      alert("An error occurred while submitting the form.");
    }
    handleCancelButton();
  };
  const handleCancelButton = () => {
    setAddPlots(false);
    setShowBtn(true);
    setShowCard(true);
    setIsRender(true);
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    setSelectedFiles((prevFiles) => [...prevFiles, ...files]);
  };


  const renderUploadedFiles = () => {
    return selectedFiles.map((file, index) => (
      <Box
        key={index}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1,
          marginTop: 2,
          padding: 1,
          border: "1px solid #ccc",
          borderRadius: 2,
          position: "relative",
        }}
      >
        <img
          src={URL.createObjectURL(file)}
          alt={`uploaded-preview-${index}`}
          style={{ maxWidth: "150px", maxHeight: "150px", borderRadius: 2 }}
        />
        <Typography sx={{ fontFamily: fonts.poppins }}>{file.name}</Typography>
        <IconButton
          size="small"
          onClick={() => handleRemoveFile(index)}
          sx={{ position: "absolute", right: 0, top: 0, padding: 1 }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
    ));
  };

  const handleRemoveFile = (index) => {
    setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  return (
    <form onSubmit={handleSubmit} method="post" enctype="multipart/form-data">
      <Box>
        <Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              justifyContent: "space-between",
              alignItems: isMobile ? "flex-start" : "center",
              gap: isMobile ? 1 : 0,
            }}
          >
            <Typography
              sx={{
                color: colors.primary_dark,
                fontSize: isMobile ? size.body : size.subtitle,
                fontWeight: 600,
                marginBottom: isMobile ? 0.5 : 1,
                textAlign: isMobile ? "left" : "inherit",
              }}
            >
              {t("plotDetails")}
            </Typography>
            <ClearIcon
              sx={{
                color: colors.red,
                alignSelf: isMobile ? "flex-end" : "center",
                cursor: "pointer",
              }}
              onClick={handleCancelButton}
            />
          </Box>

          <Divider />

          <Box sx={{ marginTop: 2 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                gap: 2,
                marginBottom: 2,
              }}
            >
              <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
                <Typography
                  sx={{
                    fontFamily: fonts.poppins,
                    fontSize: size.formLabel,
                    fontWeight: 500,
                    marginBottom: "4px",
                    color: colors.text,
                  }}
                >
                  {t("country")}
                </Typography>
                <CountrySelect
                  onChange={(e) => {
                    setCountry(e.name);
                    setCountryid(e.id);
                  }}
                  placeHolder="Select Country"
                  defaultValue={{ id: 101, name: "India" }}
                  value={"India"}
                  required
                  disabled
                  sx={{ width: isMobile ? "100%" : "auto" }}
                />
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
                <Typography
                  sx={{
                    fontFamily: fonts.poppins,
                    fontSize: size.formLabel,
                    fontWeight: 500,
                    marginBottom: "4px",
                    color: colors.text,
                  }}
                >
                  {t("state")}
                </Typography>

                <StateSelect
                  countryid={countryid}
                  onChange={(e) => {
                    setState(e.name);
                    setstateid(e.id);
                  }}
                  placeHolder="Select State"
                  required
                  onClick={() => {
                    setShowCountry(true);
                  }}
                  sx={{ width: isMobile ? "100%" : "auto" }}
                />
              </Box>
              {showCountry && (
                <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
                  <Typography
                    sx={{
                      fontFamily: fonts.poppins,
                      fontSize: size.formLabel,
                      fontWeight: 500,
                      marginBottom: "4px",
                      color: colors.text,
                    }}
                  >
                    {t("tahsil")}
                  </Typography>
                  <CitySelect
                    countryid={countryid}
                    stateid={stateid}
                    onChange={(e) => {
                      setTaluka(e.name);
                    }}
                    placeHolder="Select City"
                    required
                    sx={{ width: isMobile ? "100%" : "auto" }}
                  />
                </Box>
              )}
            </Box>

            {/* Village & Crop Selection */}
            <Box
              sx={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                gap: 2,
                marginBottom: 2,
              }}
            >
              <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
                <Typography
                  sx={{
                    fontFamily: fonts.poppins,
                    fontSize: size.formLabel,
                    fontWeight: 500,
                    marginBottom: "4px",
                    color: colors.text,
                  }}
                >
                  {t("village")}
                </Typography>
                <TextField
                  placeholder="Enter Village"
                  onChange={(event) => setVillage(event.target.value)}
                  name="village"
                  size="small"
                  required
                  fullWidth
                />
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
                <Typography
                  sx={{
                    fontFamily: fonts.poppins,
                    fontSize: size.formLabel,
                    fontWeight: 500,
                    marginBottom: "4px",
                    color: colors.text,
                  }}
                >
                  {t("selectCategory")}
                </Typography>
                <FormControl size="small" fullWidth>
                  <Select
                    value={selectedCategory}
                    onChange={(event) =>
                      setSelectedCategory(event.target.value)
                    }
                    onClick={() => {
                      setShowSubCat(true);
                    }}
                  >
                    {categories.map((category) => (
                      <MenuItem
                        key={category._id}
                        value={category.categoryType}
                      >
                        {category.categoryType}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              {showSubCat && (
                <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
                  <Typography
                    sx={{
                      fontFamily: fonts.poppins,
                      fontSize: size.formLabel,
                      fontWeight: 500,
                      marginBottom: "4px",
                      color: colors.text,
                    }}
                  >
                    {t("selectSubCrop")}
                  </Typography>
                  <FormControl size="small" fullWidth>
                    <Select
                      value={selectedSubCategory}
                      onChange={(event) =>
                        setSelectedSubCategory(event.target.value)
                      }
                    >
                      {subCategories.map((subcategory) => (
                        <MenuItem key={subcategory} value={subcategory}>
                          {subcategory}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              )}
            </Box>

            {/* Plot Area, Amount, Contact Number */}
            <Box
              sx={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                gap: 2,
                marginBottom: 2,
              }}
            >
              {/* Plot Area */}
              <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
                <Typography
                  sx={{
                    fontFamily: fonts.poppins,
                    fontSize: size.formLabel,
                    fontWeight: 500,
                    marginBottom: "4px",
                    color: colors.text,
                  }}
                >
                  {t("area")}
                </Typography>
                <FormControl variant="outlined" size="small" fullWidth>
                  <OutlinedInput
                    endAdornment={
                      <FormControl fullWidth size="small">
                        <Select
                          value={selectedAreaUnit}
                          onChange={handleChange}
                          name="areaUnit"
                          displayEmpty
                        >
                          <MenuItem value="" disabled>
                            Area Unit
                          </MenuItem>
                          <MenuItem value="Acre">Acre</MenuItem>
                          <MenuItem value="Hectare">Hectare</MenuItem>
                          <MenuItem value="Guntha">Guntha</MenuItem>
                        </Select>
                      </FormControl>
                    }
                    placeholder={`area ${selectedAreaUnit}`}
                    onChange={handleChange}
                    name="area"
                  />
                </FormControl>
              </Box>

              {/* Amount */}
              <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
                <Typography
                  sx={{
                    fontFamily: fonts.poppins,
                    fontSize: size.formLabel,
                    fontWeight: 500,
                    marginBottom: "4px",
                    color: colors.text,
                  }}
                >
                  {t("amount")}
                </Typography>
                <FormControl size="small" fullWidth>
                  <OutlinedInput
                    startAdornment={
                      <InputAdornment
                        position="start"
                        sx={{ fontFamily: fonts.poppins }}
                      >
                        ₹
                      </InputAdornment>
                    }
                    onChange={handleChange}
                    name="amount"
                  />
                </FormControl>
              </Box>

              {/* Contact Number */}
              <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
                <Typography
                  sx={{
                    fontFamily: fonts.poppins,
                    fontSize: size.formLabel,
                    fontWeight: 500,
                    marginBottom: "4px",
                    color: colors.text,
                  }}
                >
                  {t("contactNo")}
                </Typography>
                <TextField
                  size="small"
                  value={userData.phoneNumber}
                  onChange={handleChange}
                  name="contactNumber"
                  fullWidth
                />
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              gap: 2,
            }}
          >
            <Box>
              <Typography
                sx={{
                  fontFamily: fonts.poppins,
                  fontSize: size.formLabel,
                  fontWeight: 500,
                  marginBottom: "4px",
                  color: colors.text,
                }}
              >
                {t("addPhotos")}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <Button
                  component="label"
                  variant="contained"
                  startIcon={<CloudUploadIcon />}
                  sx={{
                    backgroundImage: colors.button,
                    padding: isMobile ? "6px 16px" : "8px 20px",
                    fontSize: isMobile ? "14px" : "16px",
                    textTransform: "none",
                    borderRadius: 2,
                    width: isMobile ? "100%" : "auto",
                  }}
                >
                  {t("uploadFiles")}
                  <input
                    type="file"
                    onChange={handleFileChange}
                    multiple
                    accept="image/*"
                    style={{ display: "none" }}
                  />
                </Button>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              gap: 2,
            }}
          >
            {renderUploadedFiles()}
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              gap: 2,
              marginTop: 4,
              marginBottom: 1,
              justifyContent: "center", // Centers the button properly
              alignItems: "center",
            }}
          >
            {!isMobile && <Box sx={{ flex: 1 }}></Box>}

            <Box
              sx={{
                flex: isMobile ? "none" : 1,
                width: isMobile ? "100%" : "auto",
              }}
            >
              <Button
                sx={{
                  backgroundImage: colors.button,
                  width: "100%",
                  padding: isMobile ? "6px 16px" : "8px 20px",
                  fontSize: isMobile ? "14px" : size.formLabel,
                  textTransform: "none",
                  borderRadius: 2,
                }}
                variant="contained"
                onClick={handleSubmit}
              >
                {t("submitPlot")}
              </Button>
            </Box>

            {!isMobile && <Box sx={{ flex: 1 }}></Box>}
          </Box>
        </Box>
      </Box>
    </form>
  );
};

/* ===== NEW FIGMA UI (ONE FOLD) ===== */

const farmerTranslations = {
  en: {
    sellYourCrop: "Sell Your Crop",
    step1: "Step 1/6",
    addPhotosTitle: "Add Photos",
    addPhotosSub: "Good photos help buyers trust your listing",
    addPhotoBtn: "Add Photo",
    continue: "Continue"
  },
  hi: {
    sellYourCrop: "अपनी फसल बेचे",
    step1: "चरण 1/6",
    addPhotosTitle: "तस्वीरें जोड़ें",
    addPhotosSub: "अच्छी तस्वीरें खरीदारों को आपकी लिस्टिंग पर भरोसा करने में मदद करती हैं",
    addPhotoBtn: "तस्वीर जोड़ें",
    continue: "आगे बढ़ें"
  },
  mr: {
    sellYourCrop: "तुमचे पीक विका",
    step1: "पायरी 1/6",
    addPhotosTitle: "फोटो जोडा",
    addPhotosSub: "चांगले फोटो खरेदीदारांना तुमच्या लिस्टमधील उत्पादनावर विश्वास ठेवण्यास मदत करतात",
    addPhotoBtn: "फोटो जोडा",
    continue: "पुढे जा"
  }
};

const AddPlotsStep1 = ({
  setShowCard,
  setShowBtn,
  setAddPlots,
  userData,
  onFileCancel,
  setIsRender
}) => {
  const { i18n } = useTranslation();
  const langCode = i18n.language || 'en';
  const currentLang = langCode.startsWith('hi') ? 'hi' : langCode.startsWith('mr') || langCode.startsWith('mar') ? 'mr' : 'en';
  const tLocal = farmerTranslations[currentLang];

  const [selectedFiles, setSelectedFiles] = useState([]);
  const fileInputRef = useRef(null);

  const handleBackClick = () => {
    if (setAddPlots) setAddPlots(false);
    if (setShowBtn) setShowBtn(true);
    if (setShowCard) setShowCard(true);
    if (setIsRender) setIsRender(true);
    if (onFileCancel) onFileCancel();
  };

  const handleFileSelect = (event) => {
    const files = Array.from(event.target.files);
    setSelectedFiles((prev) => [...prev, ...files]);
  };

  const handleRemoveFile = (indexToRemove) => {
    setSelectedFiles((prev) => prev.filter((_, idx) => idx !== indexToRemove));
  };

  return (
      <Box sx={{
        width: '100%',
        minHeight: '100vh',
        backgroundColor: colors.white_bg || '#FFFFFF',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}>
      {/* ======= TOP NAVIGATION BAR ======= */}
      <Box sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        height: { xs: '64px', md: '92px' },
        px: 0
      }}>
        <Box sx={{
          width: '100%',
          maxWidth: '1536px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          position: 'relative'
        }}>
          <Box
            onClick={handleBackClick}
            sx={{
              width: '40px',
              height: '40px',
              borderRadius: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              '&:hover': {
                backgroundColor: colors.background2
              }
            }}
          >
            <IconArrowLeft size={24} color={colors.text_dark || '#171C17'} />
          </Box>

          <Typography sx={{
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            fontFamily: fonts.poppins,
            fontWeight: 600,
            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: '-0.4px',
            color: colors.text_dark || '#171C17'
          }}>
            {tLocal.sellYourCrop}
          </Typography>

          <Typography sx={{
            fontFamily: fonts.poppins,
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '20px',
            color: colors.text || '#6D786D'
          }}>
            {tLocal.step1}
          </Typography>
        </Box>
      </Box>

      {/* ======= PROGRESS BAR ======= */}
      <Box sx={{ width: '100%', maxWidth: '1536px', px: 0 }}>
        <Box sx={{
          width: '100%',
          height: '4px',
          backgroundColor: colors.step_bg || colors.primary_rgba_20,
          borderRadius: '9999px',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <Box sx={{
            width: '16.666%', /* 1/6 completion */
            height: '100%',
            backgroundColor: colors.primary,
            borderRadius: '9999px',
            position: 'absolute',
            left: 0,
            top: 0
          }} />
        </Box>
      </Box>
      <Box sx={{
        width: '100%',
        height: '1px',
        backgroundColor: colors.dashboard_card_border || '#E0E5EB',
        display: { xs: 'block', md: 'none' }
      }} />

      {/* ======= MAIN FORM CONTENT ======= */}
      <Box sx={{
        width: '100%',
        maxWidth: '480px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        mt: { xs: '32px', md: '64px' },
        px: { xs: 2, md: 0 },
        pb: '160px' // Space for fixed bottom CTA
      }}>
        <Typography sx={{
          fontFamily: fonts.poppins,
          fontWeight: 700,
          fontSize: '24px',
          lineHeight: '32px',
          letterSpacing: '-0.6px',
          color: colors.text_dark || '#171C17',
          textAlign: 'center',
          mb: '8px'
        }}>
          {tLocal.addPhotosTitle}
        </Typography>

        <Typography sx={{
          fontFamily: fonts.poppins,
          fontWeight: 400,
          fontSize: '16px',
          lineHeight: '24px',
          color: colors.text || '#6D786D',
          textAlign: 'center',
          mb: '48px'
        }}>
          {tLocal.addPhotosSub}
        </Typography>

        {/* Upload Section Grid */}
        <Box sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: '16px',
          width: '100%',
          mb: 4
        }}>
          {selectedFiles.map((file, index) => (
            <Box key={index} sx={{
              width: '152px',
              height: '152px',
              borderRadius: '24px',
              position: 'relative',
              overflow: 'hidden',
              backgroundColor: colors.background2
            }}>
              <img
                src={URL.createObjectURL(file)}
                alt={`upload-${index}`}
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
              <Box
                onClick={() => handleRemoveFile(index)}
                sx={{
                  position: 'absolute',
                  top: '8px',
                  right: '8px',
                  width: '24px',
                  height: '24px',
                  borderRadius: '50%',
                  backgroundColor: '#EF4444',
                  color: '#FFFFFF',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  boxShadow: '0px 2px 4px rgba(0,0,0,0.2)'
                }}
              >
                <IconX size={14} stroke={3} />
              </Box>
            </Box>
          ))}

          {/* Add Photo Dashed Box */}
          <Box
            onClick={() => fileInputRef.current && fileInputRef.current.click()}
            sx={{
              width: '152px',
              height: '152px',
              borderRadius: '24px',
              border: `2px dashed ${colors.dashed_border || '#E3E8E3'}`,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '4px',
              cursor: 'pointer',
              backgroundColor: colors.white_bg || '#FFFFFF',
              transition: 'all 0.2s',
              '&:hover': {
                backgroundColor: colors.background_light
              }
            }}
          >
            <IconUpload size={24} color={colors.text || '#6D786D'} stroke={1.5} />
            <Typography sx={{
              fontFamily: fonts.poppins,
              fontWeight: 400,
              fontSize: '12px',
              lineHeight: '16px',
              color: colors.text || '#6D786D',
              mt: '4px'
            }}>
              {tLocal.addPhotoBtn}
            </Typography>
            <input
              type="file"
              multiple
              accept="image/*"
              ref={fileInputRef}
              style={{ display: 'none' }}
              onChange={handleFileSelect}
            />
          </Box>
        </Box>

      </Box>

      {/* ======= FIXED BOTTOM CTA CONTAINER ======= */}
      <Box sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: colors.white_bg || '#FFFFFF',
        borderTop: `1px solid ${colors.dashboard_card_border || '#E0E5EB'}`,
        padding: { xs: '16px', md: '24px' },
        zIndex: 10
      }}>
        <Box
          component="button"
          sx={{
            width: '100%',
            maxWidth: '480px',
            height: '44px',
            borderRadius: '24px',
            backgroundColor: colors.primary,
            color: colors.white_bg || '#FFFFFF',
            border: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            fontFamily: fonts.poppins,
            fontWeight: 600,
            fontSize: '14px',
            cursor: 'pointer',
            boxShadow: colors.btn_shadow_upload || '0px 4px 16px -4px rgba(0, 0, 0, 0.1), 0px 2px 8px -2px colors.primary_rgba_10',
            transition: 'background-color 0.2s',
            '&:hover': {
              backgroundColor: colors.primary_dark || '#149343'
            }
          }}
        >
          {tLocal.continue} <IconArrowLeft size={16} style={{ transform: 'rotate(180deg)' }} />
        </Box>
      </Box>
      </Box>
  );
};


// ===== EXPORT =====
const AddPlots = (props) => { return <AddPlotsStep1 {...props} />; };
export default AddPlots;
